import { useState } from 'react';
import classNames from 'classnames';
import { t } from 'ttag';

import { Button } from '@ui/Button';
import { Checkbox } from '@ui/Checkbox';
import { Input } from '@ui/Input';
import {
  useIndexedFilters,
} from '@hook/productFilters';
import { FeedCharacteristicsFilterTitle } from '@components/FeedCharacteristicsFilterTitle';

import s from './ProductCharacteristicsFilter.sss';

// hide search input when amount of items is less than this value
const LIMIT_OF_ITEMS_FOR_HIDE_SEARCH_INPUT = 10;
// show only first MAX_FOR_SHOWING items
const MAX_FOR_SHOWING = 10;

// types
export type Option = {
  id: number,
  title: string,
  icon?: string | null,
  description?: string | null,
  isIndexed: boolean,
};

type ProductCharacteristicsFilterProps = {
  className?: string;
  items: Option[];
  title: string;
  value: number[];
  onChange: (item: Option) => void;
};

export const ProductCharacteristicsFilter: React.FC<ProductCharacteristicsFilterProps> = ({
  className,
  items,
  title,
  value,
  onChange,
}) => {
  const { generateIndexedFilterPath } = useIndexedFilters();

  const [searchText, setSearchText] = useState<string>('');
  const [isActive, setIsActive] = useState(false);
  const [isShowRest, setIsShowRest] = useState(false);

  const filterItems = (item: Option) => (
    item.title.toLowerCase().startsWith(searchText.toLowerCase())
  );
  const sortItems = (item: Option) => (value.includes(item.id) ? -1 : 1);

  // hide input when !searchText, because when user search items,
  // length of founded items can be less than LIMIT_OF_ITEMS_FOR_HIDE_SEARCH_INPUT
  // and input will be hidden(it is bug)
  const hideSearchInput = items.length <= LIMIT_OF_ITEMS_FOR_HIDE_SEARCH_INPUT && !searchText;
  const transformItems = items.filter(filterItems).sort(sortItems);
  const restItemsCount = transformItems.length > MAX_FOR_SHOWING
    ? transformItems.length - MAX_FOR_SHOWING
    : 0;
  const showedItems = isShowRest ? transformItems : transformItems.slice(0, MAX_FOR_SHOWING);

  return (
    (
      <div className={classNames(s.root, className)}>
        <FeedCharacteristicsFilterTitle
          title={title}
          hide={isActive}
          options={items}
          onClick={() => setIsActive((prev) => !prev)}
        />
        <div className={classNames(s.items, { [s.displayBlock]: !isActive })}>
          {!hideSearchInput && (
          <div className={s.inputContainer}>
            <Input
              placeholder={t`Пошук`}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          )}
          <ul>
            {showedItems.map((option, i) => {
              return (
                <li key={i} className={s.listItem}>
                  <Button
                    className={s.optionButton}
                    theme='text'
                    {...(option.isIndexed && {
                      to: generateIndexedFilterPath({ characteristics: [option.id] }),
                    })}
                    onClick={(e) => {
                      e.preventDefault();

                      onChange(option);
                    }}
                  >
                    <Checkbox
                      inputClassName={s.checkbox}
                      checked={value.includes(option.id)}
                    >
                      {option.title}
                    </Checkbox>
                  </Button>
                </li>
              );
            })}
            {restItemsCount > 0 && (
            <Button className={s.restButton} onClick={() => setIsShowRest((v) => !v)} theme="text">
              {isShowRest ? t`Згорнути` : t`Ще ${restItemsCount}`}
            </Button>
            )}
          </ul>
        </div>
      </div>
    )
  );
};
